import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "button"]

  connect() {
    this.updateButton()
  }

  toggleSelection() {
    this.updateButton()
  }

  updateButton() {
    const checkboxes = this.element.querySelectorAll('input[name="applicant_ids[]"]')
    const checkedCount = Array.from(checkboxes).filter(cb => cb.checked).length
    const button = this.element.querySelector('#bulk-execute-btn')
    
    if (button) {
      button.disabled = checkedCount === 0
      
      // Update button text with icon
      const iconHtml = '<i class="fas fa-bolt mr-2"></i>'
      button.innerHTML = checkedCount > 0 
        ? `${iconHtml}${checkedCount} Kandidaten sofort absagen` 
        : `${iconHtml}Ausgewählte sofort absagen`
    }
  }

  confirmSubmit(event) {
    const checkboxes = this.element.querySelectorAll('input[name="applicant_ids[]"]:checked')
    const count = checkboxes.length
    
    if (count === 0) {
      event.preventDefault()
      alert('Bitte wählen Sie mindestens einen Kandidaten aus.')
      return false
    }
    
    const confirmed = confirm(`⚡ SOFORTIGER VERSAND!\n\nMöchten Sie die Absage-E-Mails wirklich für ${count} Kandidaten SOFORT versenden?\n\nDie E-Mails werden direkt nach Bestätigung versendet.`)
    
    if (!confirmed) {
      event.preventDefault()
      return false
    }
    
    return true
  }
}

